module.exports = __webpack_public_path__ + "static/media/mari_mobile2.a3f09b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_mobile2.png
// module id = 95
// module chunks = 0